import { ExtensionFragment } from "state/gql/_types"
import { FormSchema } from "utils/forms"

export type TenantCreateFragment = Omit<ExtensionFragment, 'id' | 'tenant_id' | 'created_at' | 'order_id' | 'agent_id' | 'updated_at' | 'tenant' | 'agent' | 'order' >

const TenantExtensionCreateSchema: FormSchema<TenantCreateFragment> = {
    id: "reservations",
    title: "Extension",
    groups: {
        extension_dates: {
            label: 'Extension Dates' 
        },
        extension_terms: {
            label: 'Extension Terms' 
        }
    },
    fields: {
        start_date: {
            group: 'extension_dates',
            label: "Rental Start Date",
            type: "date-picker-future",
            grid: 8,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        },
        start_time: {
            group: 'extension_dates',
            label: "Delivery Time",
            type: "time-picker",
            grid: 4,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        },
        end_date: {
            group: 'extension_dates',
            label: "Rental End Date",
            type: "date-picker-future",
            grid: 8,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        },
        end_time: {
            group: 'extension_dates',
            label: "PickUp Time",
            type: "time-picker",
            grid: 4, 
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        },
        rental_period: {
            group: 'extension_dates',
            label: "Rental Period",
            type: "rental-period",
            grid: 12,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        },
        memo: {
            group: 'extension_dates',
            label: "Memo / Notes",
            type: "textarea",
            grid: 12,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: false,
                    message: "{field} is required"
                }
            }
        },
        day_rate: {
            group: 'extension_terms',
            label: "Day Rate",
            type: "currency",
            grid: 4,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        },
        mile_rate: {
            group: 'extension_terms',
            label: "Mile Rate",
            type: "currency",
            grid: 4,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                }
            }
        },
        sub_total: {
            group: 'extension_terms',
            label: "Sub Total",
            type: "order-subtotal",
            grid: 4,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        },
        sales_tax: {
            group: 'extension_terms',
            label: "Sales Tax",
            type: "decimal",
            grid: 4,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        },
        other_fees: {
            group: 'extension_terms',
            label: "Other Fees",
            type: "currency",
            grid: 4,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                }
            }
        },
        discount: {
            group: 'extension_terms',
            label: "Discount",
            type: "currency",
            grid: 4,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                }
            }
        },
        order_total: {
            group: 'extension_terms',
            label: "Order Total",
            type: "order-total",
            grid: 12,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        }
    }
}

export default TenantExtensionCreateSchema